export default __webpack_public_path__ + "static/media/hand-shake.3a977fb5.png";